// extracted by mini-css-extract-plugin
export default {"img":"ProfileCard_img__ATvlr","arrow":"ProfileCard_arrow__HwmgY","link":"ProfileCard_link__aRSTB"};